import gql from "graphql-tag";

import { Fragment, User } from "../types";
import { GroupFragment, GROUP_FRAGMENT } from "./Group";

export const USER_MINIMAL_FRAGMENT = gql`
  fragment UserMinimalFragment on User {
    id
    slug
    name
    avatar
  }
`;

export type UserMinimalFragment = Fragment<
  User,
  Pick<User, "id" | "slug" | "name" | "avatar">
>;

export const USER_SUMMARY_FRAGMENT = gql`
  fragment UserSummaryFragment on User {
    id
    slug
    email
    title
    name
    role
    function
    notes
    avatar
    canShow
    canAddDocument
    groups {
      ...GroupFragment
    }
  }

  ${GROUP_FRAGMENT}
`;

export type UserSummaryFragment = Fragment<
  User,
  Pick<
    User,
    | "id"
    | "slug"
    | "email"
    | "title"
    | "name"
    | "role"
    | "function"
    | "notes"
    | "avatar"
    | "canShow"
    | "canAddDocument"
  > & {
    groups: GroupFragment[];
  }
>;
